export default "__VITE_ASSET__CIcjvSD8__"